import axios, { CanceledError } from "axios";
import { useLoadingStore } from "./loading.store";

const api = axios.create({
  baseURL: "", // Use environment variables
  timeout: 10000,
  headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json'
	}
});

api.interceptors.request.use(
  (config) => {
    useLoadingStore.getState().startLoading();
    // Optionally add authorization tokens or other headers here
    return config;
  },
  (error) => {
    useLoadingStore.getState().stopLoading();
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    useLoadingStore.getState().stopLoading();
    return response;
  },
  (error) => {
    useLoadingStore.getState().stopLoading();
    // Handle global errors, e.g., unauthorized or network issues
    return Promise.reject(error);
  }
);

export default api;

export { CanceledError };
